import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TitleService {
  private titleMessage = new Subject();
  private openSidebar = new Subject();

  setTitle(title: any) {
    this.titleMessage.next();
  }

  getTitle(): Observable<any> {
    return this.titleMessage.asObservable();
  }

  setSidebar(isFullSidebar) {
    this.openSidebar.next(isFullSidebar);
  }

  getSidebar(): Observable<any> {
    return this.openSidebar.asObservable();
  }
}
